export const globals = {
  store: null,
  history: null,
};
